var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "20px", background: "#fff" } },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "shearch-lab" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", plain: "" },
              on: { click: _vm.addFlow }
            },
            [_vm._v("新增审批")]
          ),
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.createFilter, size: "small" } },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "流程名称" },
                    model: {
                      value: _vm.createFilter.flowName,
                      callback: function($$v) {
                        _vm.$set(_vm.createFilter, "flowName", $$v)
                      },
                      expression: "createFilter.flowName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "请选择流程" },
                      model: {
                        value: _vm.createFilter.orderFlag,
                        callback: function($$v) {
                          _vm.$set(_vm.createFilter, "orderFlag", $$v)
                        },
                        expression: "createFilter.orderFlag"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "全部类型", value: "" }
                      }),
                      _c("el-option", {
                        attrs: { label: "顺序审批", value: 1 }
                      }),
                      _c("el-option", { attrs: { label: "会审", value: 0 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "请选择状态" },
                      model: {
                        value: _vm.createFilter.useStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.createFilter, "useStatus", $$v)
                        },
                        expression: "createFilter.useStatus"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "全部状态", value: "" }
                      }),
                      _c("el-option", { attrs: { label: "启用中", value: 0 } }),
                      _c("el-option", { attrs: { label: "已停用", value: 1 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { "margin-right": "0px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.filterSearch(1)
                        }
                      }
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.restShearch }
                    },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.createTableData, border: "", "row-key": "flowId" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "flowName", label: "流程名称", width: "200" }
          }),
          _c("el-table-column", {
            attrs: { prop: "orderFlag", label: "审批流程", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.flowId === 0
                      ? _c("span", [
                          _vm._v(
                            "发起合同时，无需进行任何审批即可发起，请谨慎使用！"
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                "" +
                                  (scope.row.orderFlag === 1
                                    ? "顺序审批："
                                    : "会审：") +
                                  (scope.row.allPartName
                                    ? scope.row.allPartName
                                    : "-") +
                                  "\n          "
                              ) +
                              "\n        "
                          )
                        ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "已授权成员", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "top", trigger: "hover" },
                        on: {
                          show: function($event) {
                            return _vm.moreUse(scope.row)
                          }
                        }
                      },
                      [
                        _c("el-card", { staticClass: "box-card" }, [
                          _c(
                            "div",
                            {
                              staticClass: "clearfix",
                              attrs: { slot: "header" },
                              slot: "header"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                已授权成员\n                "
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#ec1c1c" } },
                                  [
                                    _vm._v(
                                      "\n                  （" +
                                        _vm._s(_vm.userNames.length + "人") +
                                        "）\n                "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "tag-box" },
                            _vm._l(_vm.userNames, function(user) {
                              return _c(
                                "el-tag",
                                {
                                  key: user.corpUserId,
                                  staticClass: "text item",
                                  attrs: { size: "small", type: "danger" }
                                },
                                [_vm._v(_vm._s(user.userName))]
                              )
                            }),
                            1
                          )
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "point",
                            attrs: { slot: "reference" },
                            slot: "reference"
                          },
                          [_vm._v(_vm._s(scope.row._scopeOfUse || "-"))]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "创建时间", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.flowId === 0
                      ? _c("span", [_vm._v("--")])
                      : _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(scope.row.createTime) +
                              "\n        "
                          )
                        ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "useStatus", label: "启用状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      {
                        style: {
                          color:
                            scope.row.useStatus === 1
                              ? "#adadad"
                              : scope.row.useStatus === 0 ||
                                scope.row.flowId === 0
                              ? "#67C23A"
                              : "#Ec1c1c"
                        }
                      },
                      [_vm._v("● ")]
                    ),
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            scope.row.useStatus === 1
                              ? "已停用"
                              : scope.row.useStatus === 0 ||
                                scope.row.flowId === 0
                              ? "启用中"
                              : "已删除"
                          ) +
                          "\n        "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "handle-wrap" },
                      [
                        scope.row.flowId !== 0
                          ? [
                              _c(
                                "p",
                                {
                                  staticClass: "color-success",
                                  class: { "dis-style": !_vm.haveAuth },
                                  on: {
                                    click: function($event) {
                                      return _vm.addFlow(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("编辑")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "color-success",
                                  class: { "dis-style": !_vm.haveAuth },
                                  on: {
                                    click: function($event) {
                                      return _vm.switchStatus(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.useStatus === 1
                                        ? "启用"
                                        : "停用"
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "color-success",
                                  class: {
                                    "dis-style":
                                      !_vm.haveAuth ||
                                      (_vm.haveAuth &&
                                        scope.row.useStatus !== 1)
                                  }
                                },
                                [
                                  scope.row.useStatus === 0
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "light",
                                            content: "流程启用中，不可删除",
                                            placement: "bottom-end"
                                          }
                                        },
                                        [_c("span", [_vm._v("删除")])]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.del(scope.row)
                                            }
                                          }
                                        },
                                        [_vm._v("删除")]
                                      )
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _c(
                          "p",
                          {
                            class: [
                              "color-success",
                              { "dis-style": !_vm.haveAuth }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.scopeOfUse(scope.row)
                              }
                            }
                          },
                          [_vm._v("成员授权")]
                        )
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "pageation" },
        [
          _c(
            "el-col",
            {
              staticClass: "page-flex-end",
              staticStyle: { padding: "30px 0" },
              attrs: { span: 24 }
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.createFilter.itemPage,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.createFilter.pageSize,
                  layout: "sizes, prev, pager, next, total",
                  total: _vm.createFilter.pageTotal
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              }),
              _c("el-go", {
                staticStyle: { "margin-right": "5px" },
                attrs: {
                  "page-size": _vm.createFilter.pageSize,
                  total: _vm.createFilter.pageTotal
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "授权范围",
            visible: _vm.useDialogVisible,
            width: "60%",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.useDialogVisible = $event
            },
            close: _vm.filterSearch
          }
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.actTabItem,
                callback: function($$v) {
                  _vm.actTabItem = $$v
                },
                expression: "actTabItem"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "未授权成员", name: _vm.CANUSE } },
                [
                  _vm.useDialogVisible
                    ? _c("scope-use", {
                        ref: "canUseRef",
                        attrs: { rowData: _vm.selectRow },
                        on: { changAuth: _vm.changAuth }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "已授权成员", name: _vm.USED } },
                [
                  _vm.useDialogVisible
                    ? _c("un-scope-use", {
                        ref: "usedRef",
                        attrs: { rowData: _vm.selectRow },
                        on: { changAuth: _vm.changAuth }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h1",
      {
        staticClass: "com-title com-ht tree-title",
        staticStyle: { "padding-top": "0" }
      },
      [
        _c("i"),
        _c("span", { staticClass: "ms" }, [
          _vm._v(
            "合同发起时审批 / 合同发起时的审批流程，审批通过后合同才能成功发送"
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bda95672", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bda95672","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/components/contractApproval/contractApproval.vue
// module id = xXEA
// module chunks = 7 55 110